(function ($) {
	'use strict';

	var THEMENAME = {

		init: function () {
			this.themeChooser();
			// this.mainMenuBlock();
			// this.submenuOpener();
			this.fixedHeader();
			this.lottieAnimation();
			this.numberCounter();
			// this.projectSlider();
			// this.eqHeightDiv1();
			// this.scrollLogo();
			// this.pillsOpener();
			// this.searchresultSlider();
			// this.blogSlider();
		},

		themeChooser: function () {
			if (localStorage.getItem('theme-mode') === "false" || localStorage.getItem('theme-mode') === "" || localStorage.getItem('theme-mode') === undefined) {
				jQuery('#customSwitch1').prop('checked', false);
				jQuery('html').removeClass('theme-dark').addClass('theme-default');
				jQuery('header').removeClass('dark-header').addClass('light-header');
			} else {
				jQuery('#customSwitch1').prop('checked', true);
				jQuery('html').removeClass('theme-default').addClass('theme-dark');
				jQuery('header').removeClass('light-header').addClass('dark-header');
			}

			jQuery('.theme-switch').on('change', '#customSwitch1', function () {
				if (this.checked) {
					jQuery('html').removeClass('theme-default').addClass('theme-dark');
					jQuery('header').removeClass('light-header').addClass('dark-header');
					localStorage.setItem('theme-mode', "true");
				} else {
					jQuery('html').removeClass('theme-dark').addClass('theme-default');
					jQuery('header').removeClass('dark-header').addClass('light-header');
					localStorage.setItem('theme-mode', "false");
				}
			});
		},

		// mainMenuBlockOld: function () {
		// 	jQuery("header").on("click", ".navbar-toggler", function () {
		// 		if (!jQuery(this).hasClass("nav-open")) {
		// 			jQuery(this).removeClass('nav-close').addClass('nav-open');

		// 		} else {
		// 			jQuery(this).removeClass('nav-open').addClass('nav-close');
		// 		}


		// 		jQuery("html").toggleClass("menu-active"); jQuery("html").hasClass("menu-active") ? (jQuery(".main-menu-block").animate({
		// 			left: "0"
		// 		}, 600, function () {
		// 			jQuery(".main-menu-block .nav-item").each(function (e) {
		// 				jQuery(this).delay(100 * e).animate({
		// 					opacity: "1",
		// 					left: "0px"
		// 				}, 600)
		// 			});
		// 		})) : (jQuery("header").css({
		// 			background: "transparent"
		// 		}), jQuery(".main-menu-block .nav-item").each(function (e) {
		// 			jQuery(this).delay(100 * e).animate({
		// 				opacity: "0",
		// 				left: "80px"
		// 			}, 300)
		// 		}), jQuery(".main-menu-block .nav-item:last-child").delay(400).animate({
		// 			opacity: "0",
		// 			left: "80px"
		// 		}, 300, function () {
		// 			jQuery(".main-menu-block").animate({
		// 				left: "-100vw"
		// 			}, 600, function () {
		// 				jQuery("header").removeAttr("style")
		// 			})
		// 		}))
		// 	});
		// 	var e = 60,
		// 		a = 0,
		// 		t = !1;




		// },

		mainMenuBlock: function () {
			jQuery("header").on("click", ".navbar-toggler", function () {
				if (!jQuery(this).hasClass("nav-open")) {
					jQuery(this).removeClass('nav-close').addClass('nav-open');

				} else {
					jQuery(this).removeClass('nav-open').addClass('nav-close');
				}


				jQuery("html").toggleClass("menu-active"); jQuery("html").hasClass("menu-active") ? (jQuery(".main-menu-block").animate({
					top: "0",height: "100dvh"
				}, 300, function () {
					jQuery(".main-menu-block .nav-item").each(function (e) {
						jQuery(this).delay(100 * e).animate({
							opacity: "1"
						}, 150)
					});
				})) : (jQuery("header").css({
					background: "transparent"
				}), jQuery(".main-menu-block .nav-item").each(function (e) {
					jQuery(this).delay(100 * e).animate({
						opacity: "0"
					}, 150)
				}), jQuery(".main-menu-block .nav-item:last-child").delay(0).animate({
					opacity: "0"
				}, 150, function () {
					jQuery(".main-menu-block").animate({
						top: "-100vw",height: "0"
					}, 500, function () {
						jQuery("header").removeAttr("style")
					})
				}))
			});
			var e = 60,
				a = 0,
				t = !1;




		},


		submenuOpener: function () {
			jQuery(".navbar-nav .submenu-opener").on('click', function (e) {
				// e.preventDefault();
				if (!jQuery(this).hasClass('closed')) {
					jQuery(this).addClass('closed');
					jQuery(this).next('ul.dropdown-menu').slideToggle();
				}
				else {
					jQuery(this).removeClass('closed');
					jQuery(this).next('ul.dropdown-menu').slideToggle();
				}

			});

		},

		fixedHeader: function () {
			jQuery(window).scroll(function () {
				var sticky = jQuery('header'),
					scroll = jQuery(window).scrollTop();

				if (scroll >= 30) sticky.addClass('sticky-header');
				else sticky.removeClass('sticky-header');
			});
		},

		lottieAnimation: function () {

			jQuery(".lottie-animation.content-lottie").length && jQuery(".lottie-animation.content-lottie").each(function () {

				var e = jQuery(this).attr("data-json");

				e && lottie.loadAnimation(

					{

						container: document.querySelectorAll(".lottie-animation.content-lottie")[0],

						renderer: "svg",

						loop: !0,

						autoplay: !0,

						path: e

					})

			});

			jQuery(".lottie-animation.footer-lottie").length && jQuery(".lottie-animation.footer-lottie").each(function () {

				var e = jQuery(this).attr("data-json");

				e && lottie.loadAnimation(

					{

						container: document.querySelectorAll(".lottie-animation.footer-lottie")[0],

						renderer: "svg",

						loop: !0,

						autoplay: !0,

						path: e

					})

			})

		},

		numberCounter: function () {


			const easeInOutQuad = (t) => t < .5 ? 2 * t * t : -1 + (4 - 2 * t) * t;

			const inViewportCounter = (el) => {

				const duration = +el.dataset.duration || 3000;
				const start = +el.textContent || 0;
				const end = +el.dataset.count || 100;
				let raf;


				const counterStart = () => {
					if (start === end) return; // If equal values, stop here.

					const range = end - start;
					let curr = start; // Set current to start
					const timeStart = Date.now();

					const loop = () => {
						let elaps = Date.now() - timeStart;
						if (elaps > duration) elaps = duration;
						const frac = easeInOutQuad(elaps / duration); // Get the time fraction with easing
						const step = frac * range; // Calculate the value step
						curr = start + step; // Increment or Decrement current value
						el.textContent = Math.trunc(curr); // Apply to UI as integer
						if (elaps < duration) raf = requestAnimationFrame(loop); // Loop
					};

					raf = requestAnimationFrame(loop); // Start the loop!
				};

				const counterStop = (el) => {
					cancelAnimationFrame(raf);
					el.textContent = start;
				};


				const inViewport = (entries, observer) => {
					entries.forEach(entry => {
						// Enters viewport:
						if (entry.isIntersecting) counterStart(entry.target);
						// Exits viewport:
						else counterStop(entry.target);
					});
				};
				const Obs = new IntersectionObserver(inViewport);
				const obsOptions = {};
				Obs.observe(el, obsOptions);
			};

			document.querySelectorAll('[data-count]').forEach(inViewportCounter);
		},

		projectSlider: function () {
			jQuery('.project-slider').slick({
				dots: false,
				arrows: true,
				infinite: true,
				speed: 300,
				slidesToShow: 3,
				centerMode: true,
				variableWidth: false,
				responsive: [
					{
						breakpoint: 1200,
						settings: {
							slidesToShow: 2,
						}
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 1.3,
							centerMode: false,
							infinite: false,

						}
					},
				]
			});

			jQuery(".project-slider-block .left-arrow-btn").click(function () {
				jQuery(".project-slider .slick-prev ").trigger("click");
				return false;
			});

			jQuery(".project-slider-block .right-arrow-btn").click(function () {
				jQuery(".project-slider .slick-next").trigger("click");
				return false;
			});
		},

		eqHeightDiv1: function () {
			var title = 0;
			jQuery(".eq-height-img .img-container").each(function () {
				if ($(this).height() > title) { title = $(this).height(); }
			});
			jQuery(".eq-height-img .img-container").height(title);


			//on Resize change height

			jQuery(window).resize(function () {
				jQuery(".eq-height-img .img-container").height("");
				var title = 0;
				jQuery(".eq-height-img .img-container").each(function () {
					if ($(this).height() > title) { title = $(this).height(); }
				});
				jQuery(".eq-height-img .img-container").height(title);
			});

			

		},

		scrollLogo: function () {
			
			  
			  
			  // keep track of previous scroll position
			  let prevScrollPos = window.pageYOffset;
			  
			  window.addEventListener('scroll', function () {
				// current scroll position
				const currentScrollPos = window.pageYOffset;
			  
				if (prevScrollPos < currentScrollPos) {
				  // user has scrolled up
				  document.querySelector('body').classList.add('scroll-down');
				} else {
				  // user has scrolled down
				  document.querySelector('body').classList.remove('scroll-down');
				}
			  
				// update previous scroll position
				prevScrollPos = currentScrollPos;
			
			  }); 
		},

		// pillsOpener: function() {
        //     jQuery('.pills-opener').on('click', function () {

        //         jQuery('.pills-tab-wrapper').toggleClass('open-navpills');
        //         jQuery('.blog-search-result ul.nav').slideToggle();

        //     });

        //     jQuery('.pills-tab-wrapper a.nav-link').on('click', function () {

        //         jQuery('.pills-tab-wrapper').removeClass('open-navpills');
		// 		jQuery('.blog-search-result ul.nav').slideToggle();
        //     });
        // },

		searchresultSlider: function () {
			mobileOnlySlider(".search-result-slider", false, true, 9999);

			function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint) {
				var slider = $($slidername);
				var settings = {
					mobileFirst: true,
					dots: $dots,
					arrows: $arrows,
					autoplay: false,
				infinite: false,

					responsive: [
						{
							breakpoint: $breakpoint,
							settings: "unslick",
							
						},
						{
							breakpoint: 1199,
							settings: {
								slidesToShow: 3,
								slidesToScroll: 1
							}
						}, 
						{
							breakpoint: 767,
							settings: {
								slidesToShow: 2,
								slidesToScroll: 1
							}
						}, 
						{
							breakpoint: 0,
							settings: {
								slidesToShow: 1,
								slidesToScroll: 1
							}
						},
					]
				};

				slider.slick(settings);

				$(window).on("resize", function () {
					if ($(window).width() > $breakpoint) {
						return;
					}
					if (!slider.hasClass("slick-initialized")) {
						return slider.slick(settings);
					}
				});
			} // Mobile Only Slider

			jQuery(".single-search-result-wrapper .left-arrow-btn").click(function () {
				jQuery(".search-result-slider .slick-prev ").trigger("click");
				return false;
			});

			jQuery(".single-search-result-wrapper .right-arrow-btn").click(function () {
				jQuery(".search-result-slider .slick-next").trigger("click");
				return false;
			});

		
		},

	
		blogSlider: function () {
			jQuery('.blog-slider').slick({
				dots: false,
				arrows: true,
				infinite: false,
				speed: 300,
				slidesToShow: 3,
				variableWidth: false,
				responsive: [
					{
						breakpoint: 1200,
						settings: {
							slidesToShow: 2,
						}
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 1,

						}
					},
				]
			});

			jQuery(".blog-slider-block .left-arrow-btn").click(function () {
				jQuery(".blog-slider .slick-prev ").trigger("click");
				return false;
			});

			jQuery(".blog-slider-block .right-arrow-btn").click(function () {
				jQuery(".blog-slider .slick-next").trigger("click");
				return false;
			});
		},

	};

	THEMENAME.init();

})(jQuery);


